<template>
  <NuxtLoadingIndicator />
  <NuxtLayout>
     <NuxtPage />
  </NuxtLayout>
  <!-- <loginDialog id="login" ref="loginDialogRef" /> -->
  <loginCom />
  <logoutDialog id="logout" ref="logoutDialogRef" />
  <ProDialog ref="proDialogRef" />
  <GlobalBizActivationDialog />
  <GlobalBizFuelAllocationDialog />
  <EnterpriseBalanceAlertDialog />
</template>

<script setup lang="ts">
// import type LoginDialog from '~/components/LoginDialog/LoginDialog.vue'
import type LogoutDialog from '~/components/LogoutDialog/index.vue'
import BasicServer from '~/services/BasicServer'
import eventBus from 'vue3-eventbus'
import { NetCode } from '~/types/const'
import { resize } from './viewport.config'
import useSystemLanguageStore from '~/store/modules/systemLaunage'
import useUserStore from '~/store/modules/user'
import useBasicStore from '~/store/modules/basic'
import useProStore from '~/store/modules/pro'
import { Token, SystemLanguageEnum } from '~/types/const'
import { storeToRefs } from 'pinia'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { containsSubstring } from '~/utils/format'
import { useCrossDomainCookie } from "@/composables/useCrossDomainCookie";
import { initConnectionErrorDetection } from '~/utils/connectionErrorDetector';
import ProDialog from "@/components/Pro/ProDialog/ProDialog.vue"
import GlobalBizActivationDialog from '~/components/GlobalBiz/ActivationDialog.vue'
import GlobalBizFuelAllocationDialog from '~/components/GlobalBiz/FuelAllocationDialog.vue'
import EnterpriseBalanceAlertDialog from '~/components/GlobalBiz/BalanceAlertDialog.vue'
import { useSiteConfig } from '~/config/useSiteConfig'
const { getCrossDomainCookie, createCrossDomainCookie } = useCrossDomainCookie();
const userStore = useUserStore()
const baseStore = useBasicStore()
const proStore = useProStore()
const { userInfo, token, bizTeamInfo }  = storeToRefs(userStore);
const { currentCoin } = storeToRefs(proStore)
const { locale, setLocale, fallbackLocale} = useI18n()
const { visitorCountryCode } = storeToRefs(baseStore)
const defer = useDefer(10)
const siteConfig = useSiteConfig()
const runtimeConfig = useRuntimeConfig()

const { setLanguage } = useSystemLanguageStore()
let langs = {"zh" : true, "en" : true, "ja" : true, "ko": true, "tw": true, "hi": true, "ar": true, "de": true, "fr": true, "id": true, "itb": true, "uk": true}
const logoutDialogRef = ref<InstanceType<typeof LogoutDialog>>()
const proDialogRef = ref<InstanceType<typeof ProDialog>>()
const enterpriseBalanceAlert = useEnterpriseBalanceAlert()
const refreshEnterpriseBalanceAlert = () => enterpriseBalanceAlert.refresh(true)

// provide('loginDialogRef', loginDialogRef)
provide('logoutDialogRef', logoutDialogRef)
provide('proDialogRef', proDialogRef)

watch(locale, (newVal, oldVal) => {
  initLanguageCurrentPrice()
})

watch(visitorCountryCode, () => {
  initLanguageCurrentPrice()
})

const getLangsCode = () => {
  console.log("getLangsCode", locale.value)
  // 直接返回 locale.value，因为 Nuxt i18n 会根据 code 自动找到对应的文件
  return locale.value
}

const thirdPartyScripts: any[] = [
  {innerHTML: `(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${runtimeConfig.public.clarityId}");`},
  {innerHTML:`CRISP_RUNTIME_CONFIG = {locale : "${getLangsCode()}"};window.$crisp=[];window.CRISP_WEBSITE_ID="${runtimeConfig.public.crispId}";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();`}
]

if (siteConfig.isAiSite.value) {
  thirdPartyScripts.push({src: 'https://accounts.google.com/gsi/client', onerror: ((error)=>{   }), async: true, defer: true})
}

useHead({
  script: thirdPartyScripts
})

function setClarity (deviceId) {
  let userIdentify = deviceId
  if (token.value && userInfo.value.id) {
    userIdentify = userInfo.value.id
  }
  if (window.clarity) {
    window.clarity("identify", `${userIdentify}`)
  }
  if (window.$crisp) {
    if (userInfo.value.email) {
      window.$crisp.push(["set", "user:email", [userInfo.value.email]]);
    }
    window.$crisp.push(["set", "user:nickname", [`web-${userIdentify}`]]);
  }
}

const viewport = useViewport()
onMounted(() => {
  // 初始化连接错误检测
  initConnectionErrorDetection()
  eventBus.on('updateHomePage', refreshEnterpriseBalanceAlert)
  
  resize(viewport.breakpoint?.value.includes('desktop') ? 'desktop' : 'mobile')

  let localDeviceId = localStorage.getItem("deviceId")
  let domainDeviceId = getCrossDomainCookie('deviceId') || ''
  console.log("localDeviceId", domainDeviceId, localDeviceId)
  if (domainDeviceId.value) {
    localStorage.setItem("deviceId", domainDeviceId.value)
  }else if (localDeviceId) {
    localStorage.setItem("deviceId", localDeviceId)
  }else {
    // 获取设备ID
    try {
      const fpPromise = FingerprintJS.load()
      fpPromise.then(fp=> fp.get()).then(result=>{
        let requestID= result.visitorId
        let deviceId = localStorage.getItem("deviceId")
        if (!deviceId) {
          localStorage.setItem("deviceId", requestID)
          deviceId = requestID
          console.log('visitorid',requestID)
        }
        setClarity(deviceId)
      })
    }catch (e) {
      console.log('visitorid error==',e)
    }
  }

  // 从本地里面拿
  if (token.value && token.value.length > 0) {
    userStore.getUserInfo().finally(() => enterpriseBalanceAlert.refresh(true))
  }

  // 这里切换页面的时候，重新获取用户信息
  document.addEventListener('visibilitychange', function (event) {
    if (!document.hidden) {
      let isDev = process.env.NODE_ENV === 'development'
      token.value = isDev ? useCookie(Token).value || "" : getCrossDomainCookie(Token).value || ""
      if (token.value.length > 0) {
        userStore.getUserInfo().finally(() => enterpriseBalanceAlert.refresh(true))
      }else {
        userStore.tokenFail()
        enterpriseBalanceAlert.refresh(true)
      }
    }
  })

  BasicServer.getCurrentLocation().then((data)=>{
    if (data.status == 'success') {
      // IP 定位只描述访客地域，不得修改 AI/VIP 站点身份或部署区域。
      baseStore.setVisitorCountry(data.data.country.code)
    }
  })
  // 检测是否为外部跳转
  const isExternalReferrer = () => {
    if (process.server) return false
    const referrer = document.referrer
    if (!referrer) return false
    
    const currentHost = window.location.hostname
    const referrerHost = new URL(referrer).hostname
    
    // 如果referrer的域名与当前域名不同，则为外部跳转
    return referrerHost !== currentHost
  }

  // 检测URL路径是否包含语言代码
  const hasLanguageInPath = () => {
    const path = window.location.pathname
    const languagePattern = /^\/(zh|en|ja|ko|tw|hi|ar|de|fr|id|itb|uk)/
    return languagePattern.test(path)
  }

  // URL语言代码到系统语言枚举的映射
  const mapUrlLangToSystemLang = (urlLang: string): SystemLanguageEnum => {
    const langMap: Record<string, SystemLanguageEnum> = {
      'zh': SystemLanguageEnum.ZH,
      'en': SystemLanguageEnum.EN,
      'ja': SystemLanguageEnum.JA,
      'ko': SystemLanguageEnum.KO,
      'tw': SystemLanguageEnum.ZH_TW,
      'hi': SystemLanguageEnum.HI,
      'ar': SystemLanguageEnum.AR,
      'de': SystemLanguageEnum.DE,
      'fr': SystemLanguageEnum.FR,
      'id': SystemLanguageEnum.ID,
      'itb': SystemLanguageEnum.ITB,
      'uk': SystemLanguageEnum.UK
    }
    return langMap[urlLang] || SystemLanguageEnum.EN
  }

  // 获取插件检测到的语言信息
  const nuxtApp = useNuxtApp()
  const detectedLanguage = nuxtApp.$detectedLanguage
  
  
  // 只有在外部跳转且URL路径不包含语言代码时，才需要从cookie设置语言
  if (isExternalReferrer() && !hasLanguageInPath()) {
    let currentLang: SystemLanguageEnum = SystemLanguageEnum.EN
    
    // 优先使用插件检测到的语言
    if (detectedLanguage) {
      currentLang = detectedLanguage as SystemLanguageEnum
      console.log("Using detected language from plugin (external referrer):", currentLang)
    } else {
      // 如果插件没有检测到语言，从cookie读取
      const cookieLang = getCrossDomainCookie('lang') || useCookie('lang')
      
      if (cookieLang.value) {
        currentLang = cookieLang.value as SystemLanguageEnum
        console.log("Setting language from cookie (external referrer):", currentLang)
        createCrossDomainCookie('lang', cookieLang.value)
      } else {
        console.log("No language detected, using default (external referrer):", SystemLanguageEnum.EN)
        currentLang = SystemLanguageEnum.EN
        createCrossDomainCookie('lang', currentLang)
      }
    }

    console.log("Setting language for external referrer:", currentLang)
    setLocale(currentLang)
    setLanguage(currentLang)
  } else {
    // 对于直接URL访问（包含语言路径）或内部跳转，让i18n模块自动处理
    console.log("Let i18n module handle language automatically")
    
    // 如果URL包含语言路径，同步系统语言状态
    if (hasLanguageInPath()) {
      const pathLang = window.location.pathname.split('/')[1]
      const systemLang = mapUrlLangToSystemLang(pathLang)
      console.log("Syncing system language state from URL:", pathLang, "->", systemLang)
      setLanguage(systemLang)
    } else if (detectedLanguage) {
      // 如果没有语言路径但有检测到的语言，同步系统语言状态
      console.log("Syncing system language state from detected language:", detectedLanguage)
      setLanguage(detectedLanguage as SystemLanguageEnum)
    }
  }
})

onBeforeUnmount(() => {
  eventBus.off('updateHomePage', refreshEnterpriseBalanceAlert)
})

function setLang(lang: SystemLanguageEnum) {
  console.log("setLang called with:", lang)
  
  // 先设置 fallbackLocale
  fallbackLocale.value = lang as any
  
  // 使用 setLocale 来触发语言切换，这会自动调用对应的 defineI18nLocale
  setLocale(lang)
  
  // 设置 locale.value
  locale.value = lang
  
  // 更新系统语言状态
  setLanguage(lang)
  
  // 更新 HTML lang 属性
  useHead({
      htmlAttrs: {
          lang: lang
      }
  })
  
  console.log("Language set to:", lang, "locale.value:", locale.value)
}

// 公共语言切换函数，确保能正确触发 defineI18nLocale
function switchLanguage(lang: SystemLanguageEnum) {
  console.log("Switching language to:", lang)
  
  eventBus.emit('switchLanguage', lang)
}

// 设置当前币种
function initLanguageCurrentPrice() {
  currentCoin.value = userStore.getCurrentCoin(locale.value).toUpperCase()
}

onBeforeMount(()=>{
  let isDevelopment = process.env.NODE_ENV === 'development'
  if (isDevelopment) {
    token.value = useCookie(Token).value || ""
  }else {
    token.value = getCrossDomainCookie(Token).value || ""
  }
  if (token.value.length > 0) {
    if (localStorage.getItem("user_token") != token.value) {
      // 这里需要清除本地用户信息
      localStorage.setItem("user_token", token.value)
      localStorage.setItem("user", JSON.stringify({}))
      userInfo.value = {}
      bizTeamInfo.value = {}
    }
    userStore.getUserInfo()
  }else {
    userStore.tokenFail()
  }
})

useHead({
  htmlAttrs: {
    lang: locale.value
  }
})
useTheme()
// 初始化第三方应用
appMountInit()
appMountInterfaceInit()
</script>
<style scoped lang="scss">
</style>
